import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 1物N価媒体プロモーション情報取得処理サービス
 *
 * @export PlanGoodsNvalPromotionService
 * @class PlanGoodsNvalPromotionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class PlanGoodsNvalPromotionService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof PlanGoodsNvalPromotionService
   */
  private successFunc: Function;

  model: KYMW0900Model;

  vo = {
    orderCode: '',
    pCode: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PlanGoodsNvalPromotionService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof PlanGoodsNvalPromotionService
   */
  execute(model: any, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPlanGoodsNvalPromotion', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof PlanGoodsNvalPromotionService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setPlanGoodsNbalPromotion(data);
      this.successFunc(data);
    }
  }
}
